module.exports = __webpack_public_path__ + "img/Onboarding_Asset_1.0e823f7f.svg";